import { styled } from '@mui/system';

export const Paper = styled('div')(({ theme }) => ({
  margin: theme.spacing(3, 4, 3, 4),
  [theme.breakpoints.down('md')]: {
    margin: theme.spacing(3, 1, 3, 1)
  }
}));
